// extracted by mini-css-extract-plugin
module.exports = {"skeletonGroup":"ArticlesSkeletonLoading_skeletonGroup__0d_xU","skeletonGroupLine":"ArticlesSkeletonLoading_skeletonGroupLine__vq172"};